var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationEmptyStateContents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #212529;\n      }\n\n      .cls-3 {\n        fill: #7e0386;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #eef0f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1365",
    "data-name": "Elipse 1365",
    className: "cls-5",
    cx: 48,
    cy: 48,
    r: 38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.23,
    y: 12.56,
    width: 48,
    height: 57.63,
    rx: 4.36,
    ry: 4.36,
    transform: "translate(-4.17 4.85) rotate(-6.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.31,72.65c-2.45,0-4.56-1.85-4.83-4.34l-5.22-48.64c-.14-1.29,.23-2.56,1.05-3.57s1.97-1.64,3.26-1.78l39.06-4.19c1.28-.14,2.56,.23,3.57,1.05,1.01,.81,1.64,1.97,1.78,3.26l5.22,48.64c.14,1.29-.23,2.56-1.05,3.57-.81,1.01-1.97,1.64-3.26,1.78l-39.06,4.19c-.17,.02-.35,.03-.52,.03ZM60.16,11.11c-.14,0-.28,0-.42,.02L20.68,15.32c-1.02,.11-1.95,.61-2.59,1.41-.65,.8-.94,1.81-.83,2.83l5.22,48.64c.23,2.12,2.13,3.65,4.25,3.42l39.06-4.19c1.02-.11,1.95-.61,2.59-1.41s.94-1.81,.83-2.83l-5.22-48.64c-.11-1.02-.61-1.95-1.41-2.59-.69-.56-1.54-.85-2.41-.85Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.01,
    y: 52.68,
    width: 33.94,
    height: 9.94,
    rx: 1.83,
    ry: 1.83,
    transform: "translate(-5.89 5.13) rotate(-6.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.26,64.71c-1.18,0-2.19-.89-2.32-2.09l-.67-6.23c-.07-.62,.11-1.23,.5-1.71,.39-.49,.95-.79,1.57-.86l30.09-3.23c.61-.06,1.23,.11,1.71,.5,.49,.39,.79,.95,.86,1.57l.67,6.23c.07,.62-.11,1.23-.5,1.71-.39,.49-.95,.79-1.57,.86l-30.09,3.23c-.08,0-.17,.01-.25,.01Zm29.43-13.13s-.1,0-.15,0l-30.09,3.23c-.36,.04-.67,.21-.9,.49s-.33,.62-.29,.98l.67,6.23c.08,.73,.74,1.26,1.47,1.19l30.09-3.23c.35-.04,.67-.21,.9-.49,.22-.28,.33-.62,.29-.98l-.67-6.23c-.04-.35-.21-.67-.49-.9-.24-.19-.53-.3-.83-.3Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.14,
    y: 21.05,
    width: 33.94,
    height: 1,
    transform: "translate(-2.08 4.54) rotate(-6.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.08,
    y: 30.31,
    width: 16.97,
    height: 1,
    transform: "translate(-3.12 3.78) rotate(-6.17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyStateContents);
export default __webpack_public_path__ + "static/media/illustration_empty-state-contents.4bdef4cb458a74270b96ea2e00d879c4.svg";
export { ForwardRef as ReactComponent };